// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f279d2d8","453":"229ecae5","485":"7d7d9ef2","799":"d996c330"}[chunkId] + ".chunk.js";
};